<template>
  <div class="withdrew-result">
    <ResultStatus type="success" :title="$t('submitted_for_processing')" />

    <div class="result-list-info">
      <md-field>
        <md-detail-item :title="$t('amount')">
          <span class="cur">Rp</span>
          {{ result.payeeAmount | fenToYanAndFormat }}
        </md-detail-item>
        <md-detail-item
          :title="$t('fee')"
        >
          <span class="cur">Rp</span>
          <span>{{ result.feeAmount | fenToYanAndFormat }}</span>
        </md-detail-item>
        <md-detail-item
          :title="$t('remit_to')"
          :content="result.payeeAccountNo | formatBackCardNo"
        />
        <md-detail-item
          :title="$t('transaction_no')"
          :content="result.tradeNo"
        />
        <md-detail-item
          :title="$t('created_time')"
          :content="result.tradeTime"
        />
      </md-field>

      <div class="description">
        <md-icon
          class="description-icon"
          name="warn"
          color="#B2B2B2"
          size="sm"
        />
        <p>
          {{ $t('withdraw_result_desc') }}
        </p>
      </div>
    </div>
    <div class="result-done-btn">
      <md-button type="primary" @click="$router.push({ name: 'Home' })">{{ $t('back_to_homepage') }}</md-button>
    </div>
  </div>
</template>

<script>
import { InputItem, Field, RadioGroup, RadioBox, Button, DetailItem, Icon } from 'mand-mobile'
import { fenToYanAndFormat } from '@/utils/format-amount'
// import formatTimestamp from '@/utils/format-timestamp'
import formatBackCardNo from '@/utils/format-backcard-no'
import ResultStatus from '@/components/ResultStatus'
import { tradeDetail } from '@/api/withdraw'

// 提现结果
export default {
  name: 'WithdrawResult',

  components: {
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [RadioBox.name]: RadioBox,
    [Button.name]: Button,
    [InputItem.name]: InputItem,
    [DetailItem.name]: DetailItem,
    [Icon.name]: Icon,
    ResultStatus
  },

  filters: {
    fenToYanAndFormat,
    // formatTimestamp (val) {
    //   return formatTimestamp(val, 'dd/MM hh:mm')
    // },
    formatBackCardNo
  },

  data () {
    return {
      result: {}
    }
  },

  async mounted () {
    this.result = await tradeDetail({ tradeNo: this.$route.query.tradeNo })
  }
}
</script>

<style scoped lang="scss">
.withdrew-result {
  width: 100%;
  height: 100%;
  padding: 0 40px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;

  .cur {
    padding-right: 12px;
  }

  .result-list-info {
    margin-top: 32px;
  }
}

.description {
  padding: 32px;
  display: flex;
  justify-content: flex-start;
  color: #b2b2b2;

  .description-icon {
    margin-top: 5px;
  }

  > p {
    margin-left: 16px;
    font-size: 24px;
    line-height: 36px;
  }
}

.result-done-btn {
  width: 100%;
  padding: 52px 0 104px;
}
</style>
